// extracted by css-extract-rspack-plugin
export default {"cls1":"NameList-cls1_1ie","cls2":"NameList-cls2_xaQ NameList-cls1_1ie"};